import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorKeyValueForm } from "./components/motorKeyValueForm";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";

const EditMotorKeyValue = () => {

  const navigate = useNavigate();
  const params = useParams();
  const paramId = params.id;
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [keyValueData, setKeyValueData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {

      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/key-value-store/${paramId}`).then(
            (res) => {
              
              const responseData = res?.data;
              if(res?.success){
                setKeyValueData((prevData) => ({
                  ...prevData,
                  keyName: responseData?.keyName,
                  sortOrder: responseData?.sortOrder,
                  category: {value: responseData?.category?.id, label: responseData?.category?.name },
                  parentKeyId: {value: responseData?.parent?.id, label: responseData?.parent?.keyName },
                  active: responseData?.isActive,
  
                  keyNameStatus: responseData?.keyName? "success" : "unchecked",
                  sortOrderStatus: responseData?.sortOrder >= 0 ? "success" : "unchecked",
                  categoryStatus: responseData?.category?.id ? "success" : "unchecked",
                  parentKeyIdStatus: responseData?.parent?.id ? "success" : "unchecked"
                }));
              }
            }
          );
        } catch (error) {
          console.error(error);
          showSnackbar(error?.response?.data?.message, "error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  const handleUpdateMotorKeyValue = async (keyValueData) => {
    const payload = {
      categoryId: keyValueData?.category?.value,
      keyName: keyValueData?.keyName,
      parentKeyId: keyValueData?.parentKeyId?.value || null,
      sortOrder: Number(keyValueData?.sortOrder),
      isActive: keyValueData?.active,
    };
    try {
      const response = await putData(`/reference/motor/key-value-store/${paramId}`, payload);
      if(response?.success){
        navigate("/motor-master/motor-keyValue");
        showSnackbar(response?.message, "success");
      }else{
        showSnackbar(response?.message || "Error Updating Motor Key Value", "error");
      }
    } catch (error) {
      console.error("Error fetching data",error)
      showSnackbar(error?.response?.data?.message, "error");
    }finally{
      setCircleLoading(false)
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton
                  onClick={() => navigate("/motor-master/motor-keyValue")}
                >
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Motor Key Value details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Motor Key Value details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorKeyValueForm
            onsubmit={handleUpdateMotorKeyValue}
            editKeyValueData={keyValueData}
          />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditMotorKeyValue;
